// src/LoginPage.js
import React, { useEffect, useState } from 'react';
import { useKindeAuth, LoginLink } from '@kinde-oss/kinde-auth-react';

function LoginPage() {
    const { isAuthenticated, tokens, login } = useKindeAuth();
    const [loginTriggered, setLoginTriggered] = useState(false);

    useEffect(() => {
        // Trigger login if not authenticated and not already triggered
        if (!isAuthenticated && !loginTriggered) {
            setLoginTriggered(true);
            if (typeof login === 'function') {
                console.log("Calling login")
                login().then(r => console.log("Login result", r));
            } else {
                console.warn('Login function not available');
            }
        }
    }, [isAuthenticated, login, loginTriggered]);

    useEffect(() => {

        if (isAuthenticated){
            console.log("User is authenticated");
        }


            if (isAuthenticated && tokens) {
            console.log('Tokens received:', tokens);
            // At this point, you can use the tokens (including the refresh token)
            // For example, store them in your app state or secure storage
        }
    }, [isAuthenticated, tokens]);

    return (
        <div style={{textAlign: 'center', padding: '20px'}}>
            <h2>{!isAuthenticated ? 'Redirecting to login...' : 'Finalizing login...'}</h2>
            <button onClick={login} type="button">Sign In</button>
        </div>
    );
}

export default LoginPage;
